export function messageResponseEvent(params) {
    return new CustomEvent("growtypeChatMessageResponseEvent", {
        detail: params
    });
}
